import { createFileRoute, Link } from "@tanstack/react-router";
import { PROCEDURES } from "@/content/inner-pages";
import { Breadcrumbs } from "@/components/site/Breadcrumbs";
import { WhatsAppIcon } from "@/components/site/WhatsAppIcon";
import { waLink } from "@/components/site/ContentPage";
import { pageHead, SITE_URL } from "@/lib/seo";

const TITLE = "Cirurgias plásticas em Foz do Iguaçu | Dr. Kelson";
const DESCRIPTION =
  "Conheça as cirurgias plásticas realizadas pelo Dr. Kelson Kawamura em Foz do Iguaçu: mommy makeover, abdominoplastia, lipoescultura, mamas e rinoplastia.";

export const Route = createFileRoute("/especialidades/")({
  head: () => pageHead({ title: TITLE, description: DESCRIPTION, path: "/especialidades" }),
  component: EspecialidadesHub,
});

const WHATSAPP = waLink("Olá! Gostaria de agendar uma avaliação com o Dr. Kelson Kawamura.");

function EspecialidadesHub() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "Cirurgias plásticas em Foz do Iguaçu",
    itemListElement: PROCEDURES.map((p, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: p.name,
      url: `${SITE_URL}${p.path}`,
    })),
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />

      <section className="kk-section kk-gradient-hero kk-inner-hero">
        <div className="kk-container kk-fade-up" style={{ textAlign: "center" }}>
          <span className="kk-eyebrow">Especialidades</span>
          <h1 className="kk-h1 kk-h1--inner">Cirurgias plásticas em Foz do Iguaçu</h1>
          <p className="kk-lead" style={{ margin: "0 auto 32px" }}>
            Cada procedimento é planejado de forma individualizada, considerando anatomia, histórico de saúde,
            expectativas e critérios de <strong>segurança</strong>. Conheça abaixo as principais áreas de atuação do Dr. Kelson
            Kawamura.
          </p>
          <div className="kk-hero__cta-row" style={{ justifyContent: "center" }}>
            <a href="#procedimentos" className="kk-button-primary">
              Ver especialidades
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M6 9l6 6 6-6" />
              </svg>
            </a>
            <a href={WHATSAPP} target="_blank" rel="noopener noreferrer" className="kk-button-secondary">
              Agendar avaliação <WhatsAppIcon />
            </a>
          </div>

        </div>
      </section>

      <Breadcrumbs items={[{ label: "Especialidades" }]} />

      <section className="kk-section" id="procedimentos">
        <div className="kk-container">
          <div className="kk-grid kk-grid-3">
            {PROCEDURES.map((p) => (
              <article key={p.slug} className="kk-card">
                <div className="kk-card__image-placeholder">
                  <img
                    src={p.image}
                    alt={`${p.name} — Dr. Kelson Kawamura, cirurgião plástico em Foz do Iguaçu`}
                    loading="lazy"
                    decoding="async"
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                </div>
                <h2 className="kk-h3">{p.name}</h2>
                <p className="kk-text">{p.cardText}</p>
                <div className="kk-badge-row" style={{ marginBottom: 8 }}>
                  {p.tags.map((t) => (
                    <span key={t} className="kk-badge">
                      {t}
                    </span>
                  ))}
                </div>
                <Link to={p.path} className="kk-card__link">
                  Ver procedimento <span aria-hidden="true">→</span>
                </Link>
              </article>
            ))}
          </div>
        </div>
      </section>



      <section className="kk-cta-fullwidth">
        <div className="kk-container" style={{ textAlign: "center" }}>
          <h2 className="kk-h2">Converse com a equipe</h2>
          <p className="kk-lead" style={{ margin: "0 auto 28px" }}>
            Agende uma <strong>avaliação individualizada</strong> para entender possibilidades, limites, cuidados e próximos passos.
          </p>
          <a href={WHATSAPP} target="_blank" rel="noopener noreferrer" className="kk-button-primary">
            Agendar avaliação <WhatsAppIcon />
          </a>
        </div>
      </section>
    </>
  );
}
